export class PageInfoDto {
  constructor(data) {
    this.totalItems = data.totalItems || 0;
    this.pageNumber = data.pageNumber || 1;
    this.pageSize = data.pageSize || 10;
    this.totalPages = data.totalPages || 0;
    this.sortOrder = data.sortOrder || null;
    this.sort = data.sort || null;
    this.search = data.search || null;
  }
}

export default PageInfoDto;
